import { useEffect } from 'react';
import { useSubcontractorProfile } from '@/contexts/SubcontractorProfileContext';
import { refreshPushTokenIfGranted } from '@/lib/pushNotifications';

// Headless. Keeps subcontractors.fcm_token current on every portal open for
// devices that already granted notification permission (no prompt, no UI).
// Admins browsing the sub portal are skipped — profile.id is their auth uuid,
// not a subcontractors row.
const PushTokenRefresher = () => {
  const { profile } = useSubcontractorProfile();
  const subId = profile?.role === 'subcontractor' ? profile.id : null;

  useEffect(() => {
    if (subId) refreshPushTokenIfGranted(subId);
  }, [subId]);

  return null;
};

export default PushTokenRefresher;
